import { render, staticRenderFns } from "./actionQue.vue?vue&type=template&id=473514ec&"
import script from "./actionQue.vue?vue&type=script&lang=js&"
export * from "./actionQue.vue?vue&type=script&lang=js&"
import style0 from "./actionQue.vue?vue&type=style&index=0&id=473514ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports